import { FC } from 'react'

import styled from 'styled-components'

import Trash from 'src/Assets/trash.svg?react'
import UserIcon from 'src/Assets/users.svg'
import { colors, device } from 'src/Helpers/constants.ts'
import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { getValueOrFallback } from 'src/Helpers/functions'
import { Client } from 'src/Redux/api/clientsApi'
import { Image } from 'src/Components/Image'
import { formatClientName } from 'src/Helpers/organizationalForm'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  background-color: ${colors.mainGray};
  padding: 10px;

  @media ${device.tabletMax} {
    padding: 20px;
  }
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media ${device.tabletMax} {
    position: absolute;
    top: 0;
    right: 0;
  }
`

const StyledButton = styled(IconButton)`
  background-color: ${colors.red} !important;

  &:hover {
    background-color: ${colors.red} !important;
  }
  margin-left: auto;
`
const ParametersContainer = styled.div`
  position: relative;
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1fr 0.5fr 1fr 1fr 1fr;

  @media ${device.tabletMax} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`

const Name = styled.span`
  font-size: 14px;
  width: 100%;
  text-align: start;
  color: ${colors.thirdGray};
  font-weight: 600;
  cursor: pointer;

  @media ${device.tabletMax} {
    max-width: unset;
  }
`

const Parameter = styled.div`
  font-size: 12px;
  max-width: 300px;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.thirdGray};
  font-weight: 600;
  justify-content: center;
  flex-shrink: 0;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 200px;

  @media ${device.tabletMax} {
    gap: 10px;
  }
`

const StyledImage = styled(Image)`
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
`

interface CatalogItemProps {
  onArchiveItem: (id: number) => void
  onEditItem: (client: Client) => void
  client: Client
  isArchiveClientAvailable: boolean
}

export const ClientItem: FC<CatalogItemProps> = ({
  onArchiveItem,
  onEditItem,
  client,
  isArchiveClientAvailable,
}) => {
  if (!client) {
    return null
  }

  const {
    name,
    id,
    imageUrl,
    legalAddress,
    inn,
    organizationalForm,
    authorityType,
  } = client

  const onArchiveItemClick = (): void => {
    onArchiveItem(id)
  }

  const onEditItemClick = (): void => {
    onEditItem(client)
  }

  return (
    <Container>
      <ParametersContainer>
        <NameWrapper onClick={onEditItemClick} data-testid='client-item-name'>
          <StyledImage src={imageUrl} fallbackSrc={UserIcon} />
          <Name>{formatClientName({ organizationalForm, name })}</Name>
        </NameWrapper>
        <Parameter>{getValueOrFallback(inn)}</Parameter>
        <Parameter>{getValueOrFallback(legalAddress)}</Parameter>
        <Parameter>{getValueOrFallback(authorityType)}</Parameter>

        <ButtonContainer>
          <StyledButton
            onClick={onArchiveItemClick}
            disabled={!isArchiveClientAvailable}
            tooltiptext={'Удалить клиента'}
            data-testid='delete-client-button'
          >
            <Trash />
          </StyledButton>
        </ButtonContainer>
      </ParametersContainer>
    </Container>
  )
}
